if (!customElements.get('mshq-product-scale')) {
  customElements.define(
    'mshq-product-scale',
    class MshqProductScale extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound === 'true') return;
        this.dataset.bound = 'true';
        try {
          this.variants = JSON.parse(this.querySelector('[data-scale-variants]')?.textContent || '[]');
        } catch (_error) {
          this.variants = [];
        }
        this.variant = this.variants.find((variant) => variant.available) || this.variants[0];
        this.addEventListener('click', (event) => {
          const tab = event.target.closest('[data-scale-tab]');
          if (tab) this.selectTab(tab.dataset.scaleTab);
        });
        this.querySelector('[data-scale-room-select]')?.addEventListener('change', () => this.update());
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data?.variant) {
              this.variant = data.variant;
              this.update();
            }
          });
        }
        this.update();
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      dimensions() {
        const value = this.variant?.options?.[0] || '';
        const matches = String(value)
          .replace(/,/g, '.')
          .match(/\d+(?:\.\d+)?/g);
        if (!matches || matches.length < 2) return null;
        const width = Number(matches[0]);
        const height = Number(matches[1]);
        return width > 0 && height > 0 ? { width, height } : null;
      }

      normalizedSize(value) {
        const matches = String(value || '')
          .replace(/,/g, '.')
          .match(/\d+(?:\.\d+)?/g);
        return matches?.length >= 2
          ? `${Number(matches[0])}x${Number(matches[1])}`
          : String(value || '')
              .trim()
              .toLowerCase();
      }

      selectTab(mode) {
        this.querySelectorAll('[data-scale-tab]').forEach((button) => {
          const active = button.dataset.scaleTab === mode;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', String(active));
        });
        this.querySelectorAll('[data-scale-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.scalePanel !== mode;
        });
        this.update();
      }

      update() {
        const dimensions = this.dimensions();
        const size = this.normalizedSize(this.variant?.options?.[0]);
        let personFound = false;
        this.querySelectorAll('[data-scale-person]').forEach((scene) => {
          const matches = this.normalizedSize(scene.dataset.size) === size;
          scene.hidden = !matches;
          if (matches) personFound = true;
        });
        const personEmpty = this.querySelector('[data-scale-person-empty]');
        if (personEmpty) personEmpty.hidden = personFound;

        const select = this.querySelector('[data-scale-room-select]');
        const scene = select?.selectedOptions?.[0];
        const roomImage = this.querySelector('[data-scale-room-image]');
        const roomEmpty = this.querySelector('[data-scale-room-empty]');
        if (!scene?.dataset.image) {
          roomImage?.removeAttribute('src');
          if (roomEmpty) roomEmpty.hidden = false;
          return;
        }
        if (roomImage) roomImage.src = scene.dataset.image;
        if (roomEmpty) roomEmpty.hidden = true;

        const wallWidth = Number(scene.dataset.wallWidth) || 300;
        const art = this.querySelector('[data-scale-art]');
        const artImage = this.querySelector('[data-scale-art-image]');
        const widthPercent = dimensions ? Math.max(5, Math.min(70, (dimensions.width / wallWidth) * 100)) : 20;
        art?.style.setProperty('--mshq-scale-width', `${widthPercent}%`);
        art?.style.setProperty('--mshq-scale-x', `${Number(scene.dataset.anchorX) || 50}%`);
        art?.style.setProperty('--mshq-scale-y', `${Number(scene.dataset.anchorY) || 45}%`);
        if (dimensions) art?.style.setProperty('--mshq-scale-ratio', `${dimensions.width} / ${dimensions.height}`);
        const variantImage = this.variant?.featured_image?.src;
        if (variantImage && artImage) artImage.src = variantImage;
      }
    },
  );
}
